import { Web3ReactProvider } from "@web3-react/core"
import {
	Web3Provider,
	ExternalProvider,
	JsonRpcFetchFunc,
} from "@ethersproject/providers"

function getLibrary(provider: ExternalProvider | JsonRpcFetchFunc) {
	const library = new Web3Provider(provider)
	library.pollingInterval = 8000

	return library
}

const Web3ProviderComponent = ({ children }) => {
	return (
		<Web3ReactProvider getLibrary={getLibrary}>
			{children}
		</Web3ReactProvider>
	)
}

export default Web3ProviderComponent
